// libs
import get from 'lodash/get';

// API
import { getCMSPageData } from 'shared/api/cms';

// Redux
import { ActionTypes } from './actions';

// helpers
import logger from 'shared/logger';

// types
import { IFetchCMSPageDataProps } from './types';

// constants
const MODULE = 'CMS_SERVICE';

export const fetchCMSPageData = ({
  headers,
  pageId,
  isMobile = true,
  webAppType,
}: IFetchCMSPageDataProps) => {
  return (dispatch: any) => {
    dispatch({
      type: ActionTypes.FETCH_CMSPAGE_DATA_PROGRESS,
    });

    return getCMSPageData({ headers, pageId, isMobile, webAppType })
      .then((data) => {
        const cmsData = get(data, 'result', {});
        const status = get(data, 'status', -1);

        // the api gives status -1 when data is not available for a particular page name
        if (Number(status) === -1) {
          dispatch({
            type: ActionTypes.FETCH_CMSPAGE_DATA_NOT_FOUND,
          });

          //@ts-ignore
          logger.error({
            MODULE,
            ERROR: 'CMS_PAGE_NOT_FOUND_ON_CMS',
            pageId,
            isMobile,
          });
          return;
        }

        dispatch({
          type: ActionTypes.FETCH_CMSPAGE_DATA_SUCCESS,
          payload: {
            data: cmsData,
          },
        });

        return data;
      })
      .catch((err) => {
        if (err.status === 404) {
          dispatch({
            type: ActionTypes.FETCH_CMSPAGE_DATA_NOT_FOUND,
          });
          logger.error({
            MODULE,
            MESSAGE: 'CMS_PAGE_NOT_FOUND',
            err,
          });
        } else {
          dispatch({
            type: ActionTypes.FETCH_CMSPAGE_DATA_FAILED,
          });
          logger.error({
            MODULE,
            MESSAGE: 'CMS_PAGE_FAILED',
            err,
          });
        }

        return Promise.reject(err);
      });
  };
};
